import { fadeUp } from '@/core/constants/animations'
import { cn } from '@/core/lib/utils/cn'
import { Motion } from '@/core/ui/atoms/motion'
import { RemoteImage } from '@/core/ui/atoms/remote-image'
import { SliderModel } from '@/features/content/types/models/slider.model'

type Props = {
  className?: string
  slides: SliderModel[]
}

export const Map: React.FC<Props> = async ({ className, slides }) => {
  const slide = slides[0]
  if (!slide) {
    return null
  }
  return (
    <Motion
      type='section'
      className={cn('flex w-full items-center justify-center', className)}
      variants={fadeUp.variants}
      initial='initial'
      whileInView='animate'
      viewport={{ once: true }}
      transition={fadeUp.transition}
    >
      <RemoteImage
        alt=''
        src={slide.image.url}
        width={1280}
        height={720}
        className='h-auto w-full'
      />
    </Motion>
  )
}
